

import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption";
import { BASE_URL } from "../../../components/BaseUrl";
import TruncatedCell from "../../../components/TruncatedCell";
import { useTranslation } from "react-i18next";

const localizer = momentLocalizer(moment);

const AbsenceCalendar = () => {
  const { t } = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;

  const [events, setEvents] = useState([]);
  const [legend, setLegend] = useState([]);
  const [loading, setLoading] = useState(true);

  // Track visible date & view
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentView, setCurrentView] = useState("month");

  // Custom navigation handlers
  const goToPreviousMonth = () => {
    const newDate = moment(currentDate).subtract(1, "month").toDate();
    setCurrentDate(newDate);
  };

  const goToNextMonth = () => {
    const newDate = moment(currentDate).add(1, "month").toDate();
    setCurrentDate(newDate);
  };

  const goToToday = () => {
    setCurrentDate(new Date());
  };

  // Fetch API
  const fetchCalendar = async () => {
    try {
      setLoading(true);

      // IMPORTANT: CALCULATE DATES FROM CURRENTDATE
      const startDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      ).toISOString().split("T")[0];

      const endDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
      ).toISOString().split("T")[0];

      console.log("Fetching:", startDate, "→", endDate);

      const res = await fetch(
        `${BASE_URL}/absences/admin/absences/calendar?start_date=${startDate}&end_date=${endDate}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const json = await res.json();

      if (!json.error) {
        const calendarDays = json.data.calendar.calendar;
        const legendList = json.data.legend;

        setLegend(legendList);

        const mappedEvents = [];

        calendarDays.forEach((day) => {
          day.absences.forEach((abs) => {
            const fullTitle = `${abs.worker.name} – ${abs.name}`;

            mappedEvents.push({
              title: fullTitle,
              tooltip: fullTitle,
              start: new Date(day.date),
              end: new Date(day.date),
              allDay: true,
              type: abs.type,
            });
          });
        });

        setEvents(mappedEvents);
      }
    } catch (err) {
      console.log("Calendar Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCalendar();
  }, [currentDate, currentView]); // fetch when changing month/week/day

  const getTypeColor = (type) => {
    const l = legend.find((x) => x.code === type);
    return l?.color || "#888";
  };

  const eventStyleGetter = (event) => {
    const color = getTypeColor(event.type);
    return {
      style: {
        backgroundColor: color,
        color: "white",
        borderRadius: "6px",
        border: "none",
        padding: "3px 6px",
      },
      title: event.tooltip,
    };
  };

  return (
    <Box
      sx={{
        height: "80vh",
        background: "white",
        borderRadius: 2,
        p: 2,
        mt: 2,
        ml: 1,
        mr: 1,
        border: "2px solid #091E4224",
      }}
    >
      {loading ? (
        <Box sx={{ textAlign: "center", mt: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          

    

          <Calendar
            localizer={localizer}
            events={events}
            popup
            date={currentDate}
            onNavigate={(date) => setCurrentDate(date)}
            // toolbar={false}
            components={{
              event: ({ event }) => (
                <TruncatedCell
                  text={event.title}
                  maxLength={18}
                  sx={{ color: "white" }}
                />
              ),
            }}
            startAccessor="start"
            endAccessor="end"
            views={["month", "week", "day"]}
            view={currentView}
            onView={(view) => setCurrentView(view)}
            defaultView="month"
            eventPropGetter={eventStyleGetter}
            style={{ height: "calc(100% - 60px)" }}
          />
        </>
      )}
    </Box>
  );
};

export default AbsenceCalendar;



